__turbopack_context__.v({
  "item": "BottomNavigation-module__Wg_RsG__item",
  "itemLabel": "BottomNavigation-module__Wg_RsG__itemLabel",
  "itemLabelActive": "BottomNavigation-module__Wg_RsG__itemLabelActive",
  "root": "BottomNavigation-module__Wg_RsG__root",
  "stampButton": "BottomNavigation-module__Wg_RsG__stampButton",
  "stampCircle": "BottomNavigation-module__Wg_RsG__stampCircle",
  "stampLabel": "BottomNavigation-module__Wg_RsG__stampLabel",
});
